module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"headline":"Электронный билет будет отправлен на указанные E-mail и телефон, будьте внимательны при вводе"},"en":{"headline":"The e-ticket will be sent to the specified E-mail and phone, be careful when entering"}}')
  delete Component.options._Ctor
}
